import { render, staticRenderFns } from "./withdrawal_detail.vue?vue&type=template&id=e4e36056&scoped=true&"
import script from "./withdrawal_detail.vue?vue&type=script&lang=js&"
export * from "./withdrawal_detail.vue?vue&type=script&lang=js&"
import style0 from "./withdrawal_detail.vue?vue&type=style&index=0&id=e4e36056&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4e36056",
  null
  
)

export default component.exports